import Footer from "app/pages/.shared/Footer/Footer";

const BrandFooter = props => <Footer {...props} showReassurance={false} />;
export default BrandFooter;
